import { render } from "./full-comparison-dialog-price.vue?vue&type=template&id=2ccc5e26&scoped=true"
import script from "./full-comparison-dialog-price.vue?vue&type=script&lang=js"
export * from "./full-comparison-dialog-price.vue?vue&type=script&lang=js"

import "./full-comparison-dialog-price.vue?vue&type=style&index=0&id=2ccc5e26&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccc5e26"]])

export default __exports__